<div class="user-settings-container">
  <user-details [currentUserDetails]="currentUserDetails"
                [isUpdatePasswordSuccess]="hasUpdatedPwd">
  </user-details>
  <div class="horizontal-seperator"></div>
  <change-pwd [currentUserDetails]="currentUserDetails"
              [isUserDetailsChanged]="isUserDetailsChanged"
              (afterUpdatePasswordCallback)="afterUpdatePasswordCallback($event)"></change-pwd>
  <div class="horizontal-seperator"></div>
  <notification-setting *ngIf="notificationSetting" [notificationSetting]="notificationSetting"></notification-setting>
  <div class="group-bottombar bottombar">
    <div class="buttons">
      <button class="button lg-button green" [disabled]="isDisableSaveBtn" (click)="saveUserData()">
        {{'common.btn.save' | translate}}
      </button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/account-setting/user-settings/user-settings.component.html